module.exports = __webpack_public_path__ + "static/media/tumblr.4e97c802.svg";